<script setup>
import {useRestaurantsStore, useUsersStore} from "@/stores"
import moment from "moment-timezone"
import {numberWithCommas} from "@/plugins/misc"
import {emailValidator, requiredValidator, urlValidator} from "@validators"
import axios from "@axios"

const props = defineProps({
  isDialogVisible: {
    type: Boolean,
    required: true
  },
  restaurant: {
    type: Object
  }
})
const emit = defineEmits([
  'update:isDialogVisible',
  'update:restaurant',
  'confirm',
  'cancel'
])
const usersStore = useUsersStore()
let myUser = null;
({myUser} = storeToRefs(usersStore))

const restaurantsStore = useRestaurantsStore()
let restaurants = null
let markets = null
let viewingDetailsRestaurant = null;
({ restaurants, markets, viewingDetailsRestaurant } = storeToRefs(restaurantsStore))

const refVForm = ref()
const formSumbitted = ref(false)

const isInfoDialogVisible = ref(false)

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}
const onClose = () => {
  emit('close', true)
  emit('update:isDialogVisible', false)
}
const onSubmit = () => {
  refVForm.value?.validate().then(({valid: isValid}) => {
    if (isValid)
      sendForm()
  })
}

const formFields = ref({
  restaurantName: props.restaurant.name,
  restaurantMarket: props.restaurant.market,
  submitterEmail: (myUser?.value ? myUser.value.email : ""),
  submitterName: (myUser?.value ? myUser.value.firstName + " " + myUser.value.lastName : ""),
  submitterPosition: "",
  restaurantGroup: ""
})

const sendForm = () => {
  axios.post('/restaurant/claim', formFields.value, {
  }).then(r => {
    formSumbitted.value = true
  }).catch(e => {
    console.error(e)
    const {errors: formErrors} = e.response.data
    errors.value = formErrors
    console.error(e.response.data)
  })}
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    max-width="500"
    :model-value="props.isDialogVisible"
    @update:model-value="updateModelValue"
  >
    <VCard class="text-center px-5 py-6 pb-0">
      <template v-if="formSumbitted">
        <div class="mt-8 text-lg font-weight-medium">
          Thanks, we'll follow-up with next steps in 24 hours
        </div>
        <VCardActions
          class="align-center justify-center gap-2 mt-4"
        >
          <VBtn
            variant="elevated"
            color="primary"
            @click="onClose"
          >
            Ok
          </VBtn>
        </VCardActions>
      </template>
      <template v-else>
        <div class="mt-0">
          <h6 class="text-lg font-weight-medium mb-0">
            {{ restaurant.name }}
          </h6>
          <p
            v-if="restaurant.market"
            class="mt-0"
          >
            {{ restaurant?.googlePlaceData?.vicinity || restaurant.market }}
          </p>

          <VForm
            ref="refVForm"
            validate-on="blur"
          >
            <template v-if="!myUser">
              <VTextField
                v-model="formFields.submitterName"
                autocomplete="none"
                label="Your Name"
                type="text"
                class="mb-2 mt-2"
                :rules="[requiredValidator]"
              />
              <VTextField
                v-model="formFields.submitterPosition"
                autocomplete="none"
                label="Position/Title"
                type="text"
                class="mb-2 mt-2"
                :rules="[requiredValidator]"
              />

              <VTextField
                v-model="formFields.submitterEmail"
                autocomplete="none"
                label="Work Email"
                type="text"
                class="mb-2 mt-2"
                :rules="[requiredValidator, emailValidator]"
              />

              <VTextField
                v-model="formFields.restaurantGroup"
                autocomplete="none"
                label="Restaurant Group (if applicable)"
                type="text"
                class="mb-2 mt-2"
              />
            </template>
            <p v-if="restaurant.name">
              I verify that I am an authorized team member/owner of {{ restaurant.name }}
            </p>
            <VBtn
              class="mt-4 mb-4"
              block
              type="submit"
              @click.prevent="onSubmit"
            >
              request access
            </VBtn>

            <VBtn
              size="large"
              variant="text"
              @click="isInfoDialogVisible = true;"
            >
              view more
            </VBtn>
          </VForm>
        </div>
      </template>
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>



  <VDialog
    max-width="500"
    :model-value="isInfoDialogVisible"
    fullscreen
  >
    <VCard class="text-center px-0 py-0 pb-0 d-inline">
      <PreferredContent :show-search="false" />
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="isInfoDialogVisible = false"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
